var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#077368"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_3088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4384 23.3871H10.749V10.4199H15.9657C16.8352 10.4199 17.6363 10.6062 18.3691 10.9789C19.1144 11.3515 19.7044 11.8794 20.1391 12.5625C20.5738 13.2456 20.7912 14.0344 20.7912 14.9286C20.7912 15.7857 20.5676 16.5744 20.1205 17.2948C19.6857 18.0152 19.0895 18.5679 18.3318 18.9529C17.6736 19.2883 16.8849 19.456 15.9657 19.456H11.4384V23.3871ZM11.4384 18.7666H15.9657C16.7606 18.7666 17.4127 18.6424 17.922 18.394C18.5803 18.0835 19.1082 17.6177 19.5056 16.9967C19.9031 16.3756 20.1018 15.6863 20.1018 14.9286C20.1018 14.1834 19.9031 13.5003 19.5056 12.8792C19.1082 12.2582 18.5741 11.7924 17.9034 11.4819C17.3941 11.2335 16.7482 11.1093 15.9657 11.1093H11.4384V18.7666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 10.4453H22.7109V12.597H22.0625V10.4453Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.195892
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_3088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9947,
    height: 12.9672,
    fill: "white",
    transform: "translate(10.749 10.4199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/prime.973e23de449b645ae97179cdb99ae43d.svg";
export { ForwardRef as ReactComponent };